function getSectionId() {
  return document.getElementById('cart-section-content')?.dataset.sectionId;
}

async function apply(line, quantity) {
  const { changeCartLine, swapSection } = window.KamCart;
  const cart = await changeCartLine(line, quantity, getSectionId());
  swapSection(cart.sections, getSectionId(), 'cart-section-content');
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('#cart-section-content [data-action]');
  if (!button) return;
  const row = button.closest('.row');
  if (!row) return;
  const line = Number(row.dataset.line);
  const qtyEl = row.querySelector('.qty span');
  const qty = Number(qtyEl?.textContent || 0);

  if (button.dataset.action === 'dec') apply(line, Math.max(0, qty - 1));
  else if (button.dataset.action === 'inc') apply(line, qty + 1);
  else if (button.dataset.action === 'remove') apply(line, 0);
});
